import React from "react";
import { getPathStyles } from "../styles/styles";
import { PathItem } from "./PathItem";
import { useAppSelector } from "../utils/hooks";
import { selectPath } from "../api/selectors";
import { useTheme } from "../contexts/ThemeContext";
import { Path as PathType } from "../types/types";

export const Path: React.FC = () => {
  const path = useAppSelector(selectPath);
  const { theme } = useTheme();

  return (
    <div style={getPathStyles(theme)}>
      {path &&
        path.map((item: PathType, index: number) => (
          <PathItem
            index={index}
            name={item.name}
            key={item.id}
            id={item.id}
            pathArray={path}
          />
        ))}
    </div>
  );
};
